module.exports = __webpack_public_path__ + "static/media/main.8e760449.png";